import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const LeftSidebarDown = ({ selectedFilters, onFilterChange }) => {
  const [openSections, setOpenSections] = useState({
    gender: true,
    kids: false,
    price: false,
    saleOffers: false,
    sports: false,
    colour: false,
    features: false,
    fit: false,
    brand: false,
    technology: false,
    bestFor: false,
    material: false
  });

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="space-y-6 pt-6">
      {/* Gender */}
      <div>
        <button 
          onClick={() => toggleSection('gender')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Gender {selectedFilters.gender.length > 0 && `(${selectedFilters.gender.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.gender ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.gender && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2" 
                checked={selectedFilters.gender.includes('Men')}
                onChange={() => onFilterChange('gender', 'Men')}
              />
              Men
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.gender.includes('Women')}
                onChange={() => onFilterChange('gender', 'Women')}
              />
              Women
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.gender.includes('Unisex')}
                onChange={() => onFilterChange('gender', 'Unisex')}
              />
              Unisex
            </label>
          </div>
        )}
      </div>

      {/* Kids */}
      <div>
        <button 
          onClick={() => toggleSection('kids')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Kids {selectedFilters.kids.length > 0 && `(${selectedFilters.kids.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.kids ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.kids && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.kids.includes('Boys')}
                onChange={() => onFilterChange('kids', 'Boys')}
              />
              Boys
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.kids.includes('Girls')}
                onChange={() => onFilterChange('kids', 'Girls')}
              />
              Girls
            </label>
          </div>
        )}
      </div>

      {/* Shop By Price */}
      <div>
        <button 
          onClick={() => toggleSection('price')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Shop By Price {selectedFilters.price.length > 0 && `(${selectedFilters.price.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.price ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.price && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.price.includes('Under ₹ 2 500.00')}
                onChange={() => onFilterChange('price', 'Under ₹ 2 500.00')}
              />
              Under ₹ 2 500.00
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.price.includes('₹ 2 501.00 - ₹ 7 500.00')}
                onChange={() => onFilterChange('price', '₹ 2 501.00 - ₹ 7 500.00')}
              />
              ₹ 2 501.00 - ₹ 7 500.00
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.price.includes('₹ 7 501.00 - ₹ 12 999.00')}
                onChange={() => onFilterChange('price', '₹ 7 501.00 - ₹ 12 999.00')}
              />
              ₹ 7 501.00 - ₹ 12 999.00
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.price.includes('Over ₹ 13 000.00')}
                onChange={() => onFilterChange('price', 'Over ₹ 13 000.00')}
              />
              Over ₹ 13 000.00
            </label>
          </div>
        )}
      </div>

      {/* Sale & Offers */}
      <div>
        <button 
          onClick={() => toggleSection('saleOffers')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Sale & Offers {selectedFilters.sale.length > 0 && `(${selectedFilters.sale.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.saleOffers ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.saleOffers && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.sale.includes('Sale')}
                onChange={() => onFilterChange('sale', 'Sale')}
              />
              Sale
            </label>
          </div>
        )}
      </div>

      {/* Sports */}
      <div>
        <button 
          onClick={() => toggleSection('sports')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Sports {selectedFilters.sports.length > 0 && `(${selectedFilters.sports.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.sports ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.sports && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.sports.includes('Lifestyle')}
                onChange={() => onFilterChange('sports', 'Lifestyle')}
              />
              Lifestyle
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.sports.includes('Running')}
                onChange={() => onFilterChange('sports', 'Running')}
              />
              Running
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.sports.includes('Football')}
                onChange={() => onFilterChange('sports', 'Football')}
              />
              Football
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.sports.includes('Training & Gym')}
                onChange={() => onFilterChange('sports', 'Training & Gym')}
              />
              Training & Gym
            </label>
            <button className="text-sm text-gray-600 hover:text-black">+ More</button>
          </div>
        )}
      </div>

      {/* Colour */}
      <div>
        <button 
          onClick={() => toggleSection('colour')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Colour {selectedFilters.colour.length > 0 && `(${selectedFilters.colour.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.colour ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.colour && (
          <div className="grid grid-cols-3 gap-4">
            {[
              { name: 'Black', color: '#000000' },
              { name: 'Blue', color: '#0080FF' },
              { name: 'Brown', color: '#8B4513' },
              { name: 'Green', color: '#90EE90' },
              { name: 'Grey', color: '#808080' },
              { name: 'Multi-Colour', pattern: true },
              { name: 'Orange', color: '#FF6600' },
              { name: 'Pink', color: '#FF69B4' },
              { name: 'Purple', color: '#800080' },
              { name: 'Red', color: '#FF0000' },
              { name: 'White', color: '#FFFFFF' },
              { name: 'Yellow', color: '#FFFF00' }
            ].map((item) => (
              <div key={item.name} className="flex flex-col items-center cursor-pointer" onClick={() => onFilterChange('colour', item.name)}>
                <div 
                  className={`w-10 h-10 rounded-full border-2 ${selectedFilters.colour.includes(item.name) ? 'border-black' : 'border-gray-300'}`}
                  style={{ 
                    backgroundColor: item.color,
                    backgroundImage: item.pattern ? 'radial-gradient(circle, black 20%, transparent 20%), radial-gradient(circle, black 20%, transparent 20%)' : 'none',
                    backgroundSize: item.pattern ? '8px 8px' : 'auto',
                    backgroundPosition: item.pattern ? '0 0, 4px 4px' : '0 0'
                  }}
                />
                <span className="text-xs mt-1 text-center">{item.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Features */}
      <div>
        <button 
          onClick={() => toggleSection('features')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Features {selectedFilters.features.length > 0 && `(${selectedFilters.features.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.features ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.features && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.features.includes('Vented')}
                onChange={() => onFilterChange('features', 'Vented')}
              />
              Vented
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.features.includes('Drawcord')}
                onChange={() => onFilterChange('features', 'Drawcord')}
              />
              Drawcord
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.features.includes('Longline')}
                onChange={() => onFilterChange('features', 'Longline')}
              />
              Longline
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.features.includes('Non-Padded Cups')}
                onChange={() => onFilterChange('features', 'Non-Padded Cups')}
              />
              Non-Padded Cups
            </label>
            <button className="text-sm text-gray-600 hover:text-black">+ More</button>
          </div>
        )}
      </div>

      {/* Fit */}
      <div>
        <button 
          onClick={() => toggleSection('fit')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Fit {selectedFilters.fit.length > 0 && `(${selectedFilters.fit.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.fit ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.fit && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.fit.includes('Oversized')}
                onChange={() => onFilterChange('fit', 'Oversized')}
              />
              Oversized
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.fit.includes('Loose')}
                onChange={() => onFilterChange('fit', 'Loose')}
              />
              Loose
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.fit.includes('Standard')}
                onChange={() => onFilterChange('fit', 'Standard')}
              />
              Standard
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.fit.includes('Slim')}
                onChange={() => onFilterChange('fit', 'Slim')}
              />
              Slim
            </label>
            <button className="text-sm text-gray-600 hover:text-black">+ More</button>
          </div>
        )}
      </div>

      {/* Brand */}
      <div>
        <button 
          onClick={() => toggleSection('brand')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Brand {selectedFilters.brand.length > 0 && `(${selectedFilters.brand.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.brand ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.brand && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.brand.includes('Nike Sportswear')}
                onChange={() => onFilterChange('brand', 'Nike Sportswear')}
              />
              Nike Sportswear
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.brand.includes('Jordan')}
                onChange={() => onFilterChange('brand', 'Jordan')}
              />
              Jordan
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.brand.includes('Kobe')}
                onChange={() => onFilterChange('brand', 'Kobe')}
              />
              Kobe
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.brand.includes('NikeLab')}
                onChange={() => onFilterChange('brand', 'NikeLab')}
              />
              NikeLab
            </label>
            <button className="text-sm text-gray-600 hover:text-black">+ More</button>
          </div>
        )}
      </div>

      {/* Technology */}
      <div>
        <button 
          onClick={() => toggleSection('technology')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Technology {selectedFilters.technology.length > 0 && `(${selectedFilters.technology.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.technology ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.technology && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.technology.includes('Dri-FIT')}
                onChange={() => onFilterChange('technology', 'Dri-FIT')}
              />
              Dri-FIT
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.technology.includes('Dri-FIT ADV')}
                onChange={() => onFilterChange('technology', 'Dri-FIT ADV')}
              />
              Dri-FIT ADV
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.technology.includes('Storm-FIT')}
                onChange={() => onFilterChange('technology', 'Storm-FIT')}
              />
              Storm-FIT
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.technology.includes('Therma-FIT')}
                onChange={() => onFilterChange('technology', 'Therma-FIT')}
              />
              Therma-FIT
            </label>
            <button className="text-sm text-gray-600 hover:text-black">+ More</button>
          </div>
        )}
      </div>

      {/* Best For */}
      <div>
        <button 
          onClick={() => toggleSection('bestFor')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Best For {selectedFilters.bestFor.length > 0 && `(${selectedFilters.bestFor.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.bestFor ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.bestFor && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.bestFor.includes('Winter Wear')}
                onChange={() => onFilterChange('bestFor', 'Winter Wear')}
              />
              Winter Wear
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.bestFor.includes('Warm Weather')}
                onChange={() => onFilterChange('bestFor', 'Warm Weather')}
              />
              Warm Weather
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.bestFor.includes('Wet Weather Conditions')}
                onChange={() => onFilterChange('bestFor', 'Wet Weather Conditions')}
              />
              Wet Weather Conditions
            </label>
          </div>
        )}
      </div>

      {/* Material */}
      <div>
        <button 
          onClick={() => toggleSection('material')}
          className="flex items-center justify-between w-full font-semibold text-sm mb-3"
        >
          <span>Material {selectedFilters.material.length > 0 && `(${selectedFilters.material.length})`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${openSections.material ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {openSections.material && (
          <div className="space-y-2">
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.material.includes('Fleece')}
                onChange={() => onFilterChange('material', 'Fleece')}
              />
              Fleece
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.material.includes('Tech Fleece')}
                onChange={() => onFilterChange('material', 'Tech Fleece')}
              />
              Tech Fleece
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.material.includes('Recycled Materials')}
                onChange={() => onFilterChange('material', 'Recycled Materials')}
              />
              Recycled Materials
            </label>
            <label className="flex items-center text-sm cursor-pointer hover:text-gray-600">
              <input 
                type="checkbox" 
                className="mr-2"
                checked={selectedFilters.material.includes('InfinaSoft')}
                onChange={() => onFilterChange('material', 'InfinaSoft')}
              />
              InfinaSoft
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftSidebarDown;
